import { TFunction } from 'i18next'
import { Suspense } from 'react'
import { RouteObject } from 'react-router-dom'
import HousiSalesBuilder from 'src/pages/landing-pages/housi-sales-builder'
import HousiSalesDetailsBuilder from 'src/pages/landing-pages/housi-sales-builder-details'
import { RedirectToExternal } from 'src/utils/redirect-url'

import { RequireSeo } from './custom'
import * as Components from './route-components'

const landingPagesRoutes = (t: TFunction): RouteObject[] => [
  {
    path: '/decor',
    element: (
      <RequireSeo title="Housi Decor">
        <Suspense fallback="">
          <Components.Decor />
        </Suspense>
      </RequireSeo>
    ),
  },
  {
    path: '/vendas',
    element: (
      <RequireSeo
        title={t('titles:sales.SEO_TITLE')}
        description={t('titles:sales.SEO_DESCRIPTION')}
      >
        <Suspense fallback="">
          <HousiSalesBuilder />
        </Suspense>
      </RequireSeo>
    ),
  },
  {
    path: '/vendas/detalhes/:enterprise',
    element: (
      <RequireSeo title={t('titles:sales.SEO_TITLE')}>
        <Suspense fallback="">
          <HousiSalesDetailsBuilder />
        </Suspense>
      </RequireSeo>
    ),
  },
  {
    path: '/blog',
    element: <RedirectToExternal url="https://blog.housi.com" />,
  },
]

export default landingPagesRoutes
